<!--suppress HtmlUnknownTag -->
<template>
  <div class="leadsource-tabs">
    <div class="tabs">
      <div
        role="button"
        class="tab"
        :class="isActiveLeadSourceTable ? 'is-active' : ''"
        @click="showLeadSource"
      >
        Lead Source
      </div>
      <div
        role="button"
        class="tab"
        :class="isActiveFirstTouchTable ? 'is-active' : ''"
        @click="showFirstTouch"
      >
        Lead First Touch
      </div>
    </div>

    <div v-show="isActiveLeadSourceTable" class="grid-module__filter table-menu">
      <LeadSourceForm />
    </div>

    <div v-show="isActiveFirstTouchTable" class="grid-module__filter table-menu">
      <LeadSourceFirstTouchForm />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LeadSourceFirstTouchForm from './LeadSourceFirstTouchForm.vue';
import LeadSourceForm from './LeadSourceForm.vue';

const TABLE_LEAD_SOURCE = 'TLS';
const TABLE_FIRST_TOUCH = 'TFT';
const MANAGE_SETTINGS_MODIFY = { resource: 'manage-settings', code: 'modify' };

export default {
  components: {
    LeadSourceFirstTouchForm,
    LeadSourceForm,
  },
  name: 'LeadSource',
  data() {
    return {
      activeTable: TABLE_LEAD_SOURCE,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(['hasAccess']),
    isActiveLeadSourceTable() {
      return this.activeTable === TABLE_LEAD_SOURCE;
    },
    isActiveFirstTouchTable() {
      return this.activeTable === TABLE_FIRST_TOUCH;
    },
    hasModifyPermission() {
      return this.hasAccess(MANAGE_SETTINGS_MODIFY, MANAGE_SETTINGS_MODIFY, true);
    },
  },
  methods: {
    showLeadSource() {
      this.activeTable = TABLE_LEAD_SOURCE;
    },
    showFirstTouch() {
      this.activeTable = TABLE_FIRST_TOUCH;
    },
    /**
     * Until 40 - control keys {arrows, backspace, delete, home ...}
     * Between 48-57 - numbers
     * Between 96-105 - numbers numlock
     * 46 - DEL key
     * 67,86,88,90 - Ctrl+{c,z,x,v}
     */
    inputFiltering(event) {
      const isInvalid = (keyCode) => keyCode === 32 || ((((keyCode < 48 || keyCode > 57)
          && (keyCode < 96 || keyCode > 105)))
        && keyCode !== 46) || event.shiftKey === true;

      const isCvCc = () => [67, 86, 88, 90].includes(event.keyCode)
        && event.ctrlKey === true;

      const isControl = () => event.keyCode !== 32 && (event.keyCode < 40 || event.keyCode === 46);

      const isSelection = () => event.target.selectionStart - event.target.selectionEnd !== 0;

      if (isControl() || isCvCc()) {
        // eslint-disable-next-line no-restricted-globals
        return;
      }

      if (isSelection() && !isInvalid(event.keyCode)) {
        return;
      }

      if (isInvalid(event.keyCode) || event.target.value.length > 8) {
        event.preventDefault();
      }
    },

    pasteFiltering(event) {
      const paste = event.clipboardData || window.clipboardData;
      const data = paste.getData('text');
      const { value } = event.target;

      if (!data.match('^\\d{0,9}$')) {
        event.preventDefault();
        this.$buefy.toast.open({
          message: 'Only numbers are allowed, max size 9',
          type: 'is-warning',
        });
      }

      if ((value.length - (event.target.selectionEnd - event.target.selectionStart)
        + data.length) > 9) {
        event.preventDefault();
        this.$buefy.toast.open({
          message: 'Only numbers are allowed, max size 9',
          type: 'is-warning',
        });
      }
    },
    /**
     * TODO: data should be copied when component has mounted
     */
    onSubmit() {
      this.$emit('submit', this.data);
    },
  },

};
</script>

<style lang="stylus" scoped>
.leadsource-tabs
  .tabs
    margin-bottom 0px
.bordered-table
  td:first-child
    border-left 1px solid rgba(143, 167, 179, 0.3)
  td:last-child
    border-right 1px solid rgba(143, 167, 179, 0.3)
.cell
  white-space inherit
.fix-size-button
  width 80px
  margin-bottom 8px
  margin-right 8px
.tabs
  display flex
  justify-content start
  border-bottom 1px solid rgba(143, 167, 179, 0.3)
  overflow visible
  .tab
    cursor pointer
    margin 0 15px
    padding-bottom: 18px
    &:first-child
      margin: 0 15px 0 0
    &.is-active
      position relative
      font-weight 600
      &:after
        content: ''
        position absolute
        bottom -1.5px
        left 0
        width 100%
        height 3px
        background rgba(23, 181, 72, 1)
</style>
